/**
 * @file paddle page feature
 * @author wanzhongyun
 */

import { IInterFeatures } from './../../types';
import './style.less';

const Features:React.FC<IInterFeatures> = props => {
    const { title, desc, list } = props;
    return <div className="paddle-page-features">
        <div className='paddle-page-features-content'>
            <div className='paddle-page-features-content-title'>{ title }</div>
            <div className='paddle-page-features-content-desc'>{ desc }</div>
            <div className='paddle-page-features-card-wrapper'>
                {
                    list.map(item => <div className='paddle-page-features-card' key={item.title + item.desc}>
                        <img className='paddle-page-features-card-image' src={item.imageUrl} alt={item.title} />
                        <div className='paddle-page-features-card-title'>{ item.title }</div>
                        <div className='paddle-page-features-card-desc'>{ item.desc }</div>
                    </div>)
                }
            </div>
        </div>
    </div>
}

export default Features;